import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import ModalHardConfirm from '../../Miscelania/ModalHardConfirm';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import TeamTrainingMatterStaffsAcoes from './TeamTrainingMatterStaffsAcoes';

class TeamStaffsTab extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      total_staff: 0,
      date_start: '',
      date_finish: '',
      modal_date_start: '',
      modal_date_finish: '',
      modal_insercao_titulo: '',
      modal_ttmse_id: null,
      modal_presence_value: null,
      team_id: null,
      exam_id: null,
      import_ttmse_id: null,
      manual_grade: null,
      staff_id: null,
      modal_props: false,
      modal_insercao: false,
      confirm_all: 0,
      confirm_full: 0,
      lista_alunos: [],
      lista_provas: [],
      dados: [],
      pending_action: null,
      modal_hard_confirm_open: false,
    };
    this.refreshTable = this.refreshTable.bind(this);
    this.adicionarAluno = this.adicionarAluno.bind(this);
    this.confirmarNaoPresencaMateria = this.confirmarNaoPresencaMateria.bind(this);
    this.confirmarPresencaMateria = this.confirmarPresencaMateria.bind(this);
    this.confirmarNaoPresenca = this.confirmarNaoPresenca.bind(this);
    this.confirmarPresenca = this.confirmarPresenca.bind(this);
    this.confirmarTodasPresencas = this.confirmarTodasPresencas.bind(this);
    this.confirmarProvas = this.confirmarProvas.bind(this);
    this.confirmarTodasProvas = this.confirmarTodasProvas.bind(this);
    this.atualizarInformacoesAlunos = this.atualizarInformacoesAlunos.bind(this);
    this.deletarAluno = this.deletarAluno.bind(this);
    this.reintegrarResultado = this.reintegrarResultado.bind(this);
    this.modalInsercaoManual = this.modalInsercaoManual.bind(this);
    this.insercaoManualCompleto = this.insercaoManualCompleto.bind(this);
    this.insercaoManualNota = this.insercaoManualNota.bind(this);
    this.openPresenceModal = this.openPresenceModal.bind(this);
    this.openAllStaffPresenceModal = this.openAllStaffPresenceModal.bind(this);
    this.openFullPresenceModal = this.openFullPresenceModal.bind(this);
    this.handleHardConfirm = this.handleHardConfirm.bind(this);
    this.confirmHardAction = this.confirmHardAction.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.alunos !== 'undefined'  && this.state.loaded === 0) {
      this.setState({dados: newProps.alunos});
      this.setState({avaliation: newProps.avaliation});
      this.setState({total_staff: Object.keys(newProps.alunos).length});
      this.setState({loaded: 1});
    }
    if(Array.isArray(newProps.lista_alunos)) {
      this.setState({lista_alunos: newProps.lista_alunos});
    }
  }

  refreshTable(event) {
    var url = config.get('api') + '/turma/alunos/buscar_alunos/'+this.props.team_id;
    var header = this.refs.request_api.header('application/json');
    this.props.handleAlert('', '', 'open');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          var alunos = responseJson.data && responseJson.data.infos ? responseJson.data.infos : responseJson.data;
          var avaliation = responseJson.data && typeof responseJson.data.avaliation !== 'undefined' ? responseJson.data.avaliation : 0;
          self.setState({
            dados: alunos || {},
            avaliation: avaliation,
            total_staff: Object.keys(alunos || {}).length
          });
        }
        if (event && event.message) {
          self.props.handleAlert(event.message, event.status, 'open');
        } else {
          self.props.handleAlert('', '', 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  handleHardConfirm = (callback) => {
    this.setState({
      modal_insercao: false, // Fecha o modal anterior
      modal_hard_confirm_open: true, // Abre o modal correto
      pending_action: callback
    });
  };

  confirmHardAction = () => {
    if (this.state.pending_action) {
      this.state.pending_action();
    }
    this.setState({ modal_hard_confirm_open: false, pending_action: null });
  };

  // métodos modificados:
  insercaoManualCompleto(id) {
    const materia = this.state.materiaSelecionada;

    const dados_salvar = {
      ttmse_id: id,
      exam_id: this.state.exam_id,
    };

    const action = () => {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/importacao/manual/prova/completo', {
          method: 'POST',
          mode: 'cors',
          headers: value,
          body: JSON.stringify(dados_salvar)
        }).then((response) => response.json()).catch((error) => {
          console.error(error);
        }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refreshTable(responseJson);
            self.setState({ modal_insercao: false });
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    };

    if (materia.result !== null && (materia.imported === 0 || materia.imported === 1)) {
      this.handleHardConfirm(action);
    } else {
      action();
    }
  }
  
  insercaoManualNota(id) {
    const materia = this.state.materiaSelecionada;

    const dados_salvar = {
      ttmse_id: id,
      manual_grade: this.state.manual_grade,
      date_start: this.state.date_start,
      date_finish: this.state.date_start,
    };

    const action = () => {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/importacao/manual/prova/nota', {
          method: 'POST',
          mode: 'cors',
          headers: value,
          body: JSON.stringify(dados_salvar)
        })
        .then((response) => response.json())
        .catch((error) => { console.error(error); })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refreshTable(responseJson);
            self.setState({ modal_insercao: false, materiaSelecionada: null });
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        })
        .catch((error) => { console.error(error); });
      });
    };

    if (materia.result !== null && (materia.imported === 0 || materia.imported === 1)) {
      this.handleHardConfirm(action);
    } else {
      action();
    }
  }

  adicionarAluno(event) {
    event.preventDefault();
    var dados_salvar = {
      staff_id: this.state.staff_id,
      team_id: this.props.team_id,
    };
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/turma/treinamento/materia/aluno', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.refreshTable(responseJson);
        } else {
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Confirmação de presença
  confirmarTodasPresencas() {

    var datasave = {
      date_start: this.state.modal_date_start,
      date_finish: this.state.modal_date_start,
      team_id: this.props.team_id,
    };

    if(this.state.avaliation == 0) {
      this.openFullPresenceModal();
    } else if (window.confirm('Tem certeza que deseja confirmar a presença de todos os alunos?')) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/turma/confirmar/presenca/todas', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.refreshTable(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  confirmarPresenca(staff_id, presence, team_id) {

    var datasave = {
      date_start: this.state.modal_date_start,
      date_finish: this.state.modal_date_finish,
      staff_id: staff_id,
      presence: presence,
      team_id: team_id,
    };

    if(this.state.avaliation == 0) {
      this.openAllStaffPresenceModal(staff_id, presence, team_id);
    } else if (window.confirm('Tem certeza que deseja confirmar a presença deste aluno?')) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/turma/treinamento/materia/aluno/confirmar_presenca', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.refreshTable(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  openPresenceModal(ttmse_id) {
    this.setState({modal_ttmse_id: ttmse_id});
    this.setState({modal_presence: true});
  }

  openFullPresenceModal() {
    this.setState({modal_presence: true});
    this.setState({avaliation: 1});
    this.setState({confirm_full: 1});
  }

  openAllStaffPresenceModal(staff_id, presence, team_id) {
    this.setState({staff_id: staff_id});
    this.setState({team_id: team_id});
    this.setState({modal_presence_value: presence});
    this.setState({modal_presence: true});
    this.setState({avaliation: 1});
    this.setState({confirm_all: 1});
  }

  modalInsercaoManual(ttmse_id, matter, materia) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/buscar/provas/equivalentes/' + ttmse_id, {
        method: 'GET',
        mode: 'cors',
        headers: value
      })
      .then((response) => response.json())
      .catch((error) => { console.error(error); })
      .then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({
            lista_provas: responseJson.data,
            import_ttmse_id: ttmse_id,
            modal_insercao_titulo: matter,
            modal_insercao: true,
            materiaSelecionada: materia, // Guarde o objeto completo aqui!
          });
        }
        self.props.handleAlert('', '', 'closed');
      })
      .catch((error) => { console.error(error); });
    });
  }

  confirmarNaoPresenca(staff_id, presence, team_id) {
    var datasave = {
      staff_id: staff_id,
      presence: presence,
      team_id: team_id,
    };
    if (window.confirm('Tem certeza que deseja confirmar a ausência deste aluno?')) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/turma/treinamento/materia/aluno/confirmar_nao_presenca', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.refreshTable(responseJson);
      }).catch((error) => {
          console.error(error);
        });
      });
    }
  }


  confirmarPresencaMateria(team_training_matter_staff_id, matter_avaliation) {
    var datasave = {
      team_training_matter_staff_id: team_training_matter_staff_id,
      date_start: this.state.modal_date_start,
      date_finish: this.state.modal_date_finish,
    };

    if(matter_avaliation == 0) {
      this.openPresenceModal(team_training_matter_staff_id);
    } else if (window.confirm('Tem certeza que deseja confirmar a presença deste aluno nesta matéria?')) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/turma/treinamento/materia/aluno/confirmar_presenca_materia', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.refreshTable(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  confirmarNaoPresencaMateria(team_training_matter_staff_id) {
    var datasave = {
      team_training_matter_staff_id: team_training_matter_staff_id,
    };
    if (window.confirm('Tem certeza que deseja confirmar a ausência deste aluno nesta matéria?')) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/turma/treinamento/materia/aluno/confirmar_nao_presenca_materia', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.refreshTable(responseJson);
      }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Atualizar informações do aluno.
  atualizarInformacoesAlunos() {
    var confirmar = window.confirm("Tem certeza que deseja atualizar as informações do aluno? As informações de presença e prova serão permanentemente perdidas!");
    if(confirmar) {
      var url = config.get('api') + '/alunos/atualizar_informacoes/' + this.props.team_id;
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.setState({status_loading: 1});
      Promise.resolve(header).then(function(value) {
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.refreshTable(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  reintegrarResultado(materia) {
    if (!window.confirm('Tem certeza que deseja tentar reenviar esta matéria para integração com o SIGTRIP/SIGMEC?')) {
      return;
    }

    var datasave = {
      team_training_matter_staff_id: materia.id,
    };

    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/turma/treinamento/materia/aluno/reintegrar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.refreshTable(responseJson);
        } else {
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  // Fetch salvando a edição
  confirmarProvas(staff_id, team_id) {
    var confirmar = window.confirm("Tem certeza que deseja confirmar as provas desse aluno?");
    if(confirmar) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        staff_id: staff_id,
        team_id: team_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/turma/treinamento/materia/aluno/confirmar_provas', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.refreshTable(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }
  // Fetch salvando a edição
  confirmarTodasProvas(team_id) {
    var confirmar = window.confirm("Tem certeza que deseja confirmar todas as provas dessa turma?");
    if(confirmar) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        team_id: this.props.team_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/turma/confirmar_todas_provas', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.refreshTable(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  showCard(event) {
    var dados = this.state.dados;
    dados[event][1].show_dados = 1;

    this.setState({dados: dados});
  }

  hideCard(event) {
    var dados = this.state.dados;
    dados[event][1].show_dados = 0;

    this.setState({dados: dados});
  }

  deletarAluno (event) {
    var team_training_matter_staff_id = event;
    var confirm = window.confirm('Tem certeza que gostaria de deletar esse aluno?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/turma/treinamento/materia/aluno/' + team_training_matter_staff_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refreshTable(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }
  export(event) {
    var team_id = event;
    var url = "/exportar/certificado/aluno/" + team_id;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <div className="info-warning"><i className="fa fa-fw fa-warning"></i> <strong>Atenção!</strong> Os alunos devem ser inseridos após confirmação dos treinamentos, matérias e provas escolhidas. Caso haja modificação, é necessário atualizar as informações dos alunos. Para isso, clique em no botão de atualizar informações dos alunos.</div>
  <form onSubmit={this.adicionarAluno}>
    <div className="row">
      <div className="form-group col-md-6">
        <label>Alunos:</label>
          <Select
            className="form-field-name"
            name="staff_id"
            value={this.state.staff_id}
            searchable={true}
            placeholder={'Selecionar Alunos'}
            onChange={this.handleSelectChange.bind(this, 'staff_id')}
            options={this.state.lista_alunos}
            required
          />
      </div>
      <div className="col-md-6">
        <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> Adicionar aluno</button>
      </div>
    </div>
  </form>
  <hr/>
  <div className="row">
    <div className="col-md-4">
      <button onClick={this.confirmarTodasPresencas} className="btn btn-success btn-lg btn-block"><i className="fa fa-fw fa-check"></i> Confirmar todas as presenças</button>
    </div>
    <div className="col-md-4">
      <button onClick={this.confirmarTodasProvas} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-tasks"></i> Confirmar todas as provas</button>
    </div>
    <div className="col-md-4">
      <button onClick={this.atualizarInformacoesAlunos} className="btn btn-info btn-lg btn-block"><i className="fa fa-fw fa-refresh"></i> Atualizar informações dos alunos</button>
    </div>
  </div>
  <hr/>
  <h3>Total de alunos: {self.state.total_staff}</h3>
  {Object.keys(self.state.dados).map(function(nome) {
    var materias = self.state.dados[nome];
    var presence = 1;
    Object.keys(materias).map(function(mat) {
      if (mat !== "0") {
        if (materias[mat].presence === 0 && presence !== null) {
          presence = 0;
        }
        if (materias[mat].presence ===  null) {
          presence = null;
        }
      }
    });
    
    return (
      <div>
        <div className="titulo-alunos-turma">
          <h4 className="pull-left"><Link to={"/aluno/editar/" + materias[1].staff_id} target="_blank">{nome}</Link></h4>
          {(materias[0].span_status === 'previsto') ?
            <span className="pull-right label label-default" style={{marginLeft: '10px', marginTop: '8px'}}>Previsto</span>
          : (materias[0].span_status === 'incompleto') ?
            <span className="pull-right label label-info" style={{marginLeft: '10px', marginTop: '8px'}}>Incompleto</span>
          : (materias[0].span_status === 'aprovado') ? <span className="label label-success" style={{marginLeft: '10px', marginTop: '8px'}}>Aprovado</span> : <span className="label label-danger" style={{marginLeft: '10px', marginTop: '8px'}}>{materias[0].span_status}</span>
          }
          {(presence === 1) ?
            <button className="pull-right btn btn-success" disabled><i className="fa fa-fw fa-check"></i> Presença</button>
           :
           ''
          }
          {(presence === 0) ?
           <button className="pull-right btn btn-danger" disabled><i className="fa fa-fw fa-close"></i> Ausência</button>
           :
           ''
          }
          {(presence !== 1 && presence !== 0) ?
            <button onClick={() => {self.confirmarNaoPresenca(materias[1].staff_id, presence, materias[1].team_id )}} className="pull-right btn btn-danger" ><i className="fa fa-fw fa-close"></i> Ausência</button>
           :
           ''
          }
          {(presence !== 1 && presence !== 0) ?
            <button onClick={() => {self.confirmarPresenca(materias[1].staff_id, presence, materias[1].team_id )}} className="pull-right btn btn-success" ><i className="fa fa-fw fa-check"></i> Confirmar presença em todas as matérias</button>
           :
           ''
          }
          {(materias[1].show_dados == 0) ?
            <button onClick={() => {self.showCard(nome)}} className="pull-right btn btn-info" ><i className="fa fa-fw fa-check"></i> Exibir</button>
           :
            <button onClick={() => {self.hideCard(nome)}} className="pull-right btn btn-warning" ><i className="fa fa-fw fa-check"></i> Esconder</button>
          }
          {(materias[0].span_status == 'previsto') ?
            <button onClick={() => {self.deletarAluno(materias[1].id)}} className="pull-right btn btn-danger" ><i className="fa fa-fw fa-trash"></i></button>
           :
            ""
          }
          {(materias[0].span_status == 'aprovado') ?
            <button className="btn btn-success btn-xs" onClick={() => {self.export(materias[1].staff_id + "/" + materias[1].team_id)}}><i className="fa fa-fw fa-download"></i></button>
           :
            ""
          }
          <div className="clearfix"></div>
        </div>
        <div hidden={(materias[1].show_dados == 0) ? 'hidden' : ''}>
          <table className="table table-hover table-stripped table-bordered">
            <thead>
              <tr>
                <th>Matéria</th>
                <th>Data de início</th>
                <th>Data de fim</th>
                <th>Material</th>
                <th>Moodle</th>
                <th>Resultado</th>
                <th>Presença</th>
              </tr>
            </thead>
            <tbody>
            {Object.keys(materias).map(function(k) {
              if(k !== "0") {
                var materia = materias[k];

                var check_exam = 0;
                var team_training_matter_staff_exam_id = 0;
                var date_exam_finished = materia.date_finish;
                Object.keys(materia.team_training_matter_staff_exams).map(function(ttmse) {
                  if (materia.team_training_matter_staff_exams[ttmse].status === 'aprovada' || materia.team_training_matter_staff_exams[ttmse].status === 'reprovada') {
                    team_training_matter_staff_exam_id = materia.team_training_matter_staff_exams[ttmse].id;
                    date_exam_finished = materia.team_training_matter_staff_exams[ttmse].date_exam_finished_str;
                  }
                  check_exam = materia.team_training_matter_staff_exams[ttmse].id;
                });

                return (
                  <tr>
                    <td width='350'>{materia.matter}</td>
                    <td width='100'>{materia.date_start}</td>
                    <td width='100'>{date_exam_finished}</td>
                    <td>
                      {(materia.material === null) ?
                        ''
                      : <button className="btn btn-warning btn-sm" onClick={() => { window.open(config.get('cdn') + '/materiais/' + materia.material); }}><i className="fa fa-fw fa-download"></i> DOWNLOAD</button>
                      }
                    </td>
                    <td>
                      {(materia.moodle_integration_status === 0) ? 
                        <span className="label label-danger">{materia.moodle_integration_status_str}</span>
                        : (materia.moodle_integration_status === 1) ?
                        <span className="label label-primary">{materia.moodle_integration_status_str}</span>
                        :
                        <span className="label label-success">{materia.moodle_integration_status_str}</span>
                      }
                    </td>
                    <td width='220'>
                      {(materia.exam_created === null) ?
                        <span className="label label-default">Prova não gerada</span>
                      : (materia.result === null) ?
                        <span className="label label-info">Prova não realizada</span>
                      :
                        <TeamTrainingMatterStaffsAcoes handleAlert={self.props.handleAlert} team_training_matter_staff_id={materia.id} approved={materia.approved} result={materia.result} />
                      }
                      {(materia.approved === 1 && materia.result !== null && materia.job_created !== 1) ?
                        <span>
                          &nbsp;
                          <button
                            className="btn btn-warning btn-xs"
                            title="Tentar reenviar integração SIGTRIP/SIGMEC"
                            onClick={() => { self.reintegrarResultado(materia); }}
                          >
                            <i className="fa fa-fw fa-refresh"></i>
                          </button>
                        </span>
                      : ''
                      }
                      {(materia.imported > 0) ?
                        <span className="label label-warning"><i className="fa fa-fw fa-warning"></i> Resultado importado</span>
                      : ''
                      }
                      {(materia.result === null && check_exam !== 0) || ((check_exam !== 0 && (materia.imported === 0 || materia.imported === 1))) ?
                        <div>
                          <button
                            className="btn btn-primary btn-xs"
                            onClick={() => {
                              self.modalInsercaoManual(materia.team_training_matter_staff_exams[0].id, materia.matter, materia);
                            }}
                          >
                            <i className="fa fa-fw fa-tasks"></i>
                          </button>
                        </div>
                      : ''
                      }
                    </td>
                    <td width='220'>
                      <div className="btn-group">
                        {(materia.presence !== 1 && materia.presence !== 0) ?
                          <button onClick={() => {self.confirmarPresencaMateria(materia.id, materia.avaliation)}} className="btn btn-success" ><i className="fa fa-fw fa-check"></i> Presente</button>
                         :
                         ''
                        }
                        {(materia.presence !== 1 && materia.presence !== 0) ?
                          <button onClick={() => {self.confirmarNaoPresencaMateria(materia.id)}} className="btn btn-danger" ><i className="fa fa-fw fa-close"></i> Ausente</button>
                         :
                         ''
                        }
                        {(materia.presence === 1) ?
                          <button className="btn btn-success" disabled><i className="fa fa-fw fa-check"></i> Presente</button>
                         :
                         ''
                        }
                        {(materia.presence === 0) ?
                         <button className="btn btn-danger" disabled><i className="fa fa-fw fa-close"></i> Ausente</button>
                         :
                         ''
                        }
                      </div>
                    </td>
                  </tr>
                );
              }
            })}
            </tbody>
          </table>
        </div>
      </div>
    );
  })}
  <Modal show={self.state.modal_presence} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4>Inserção de data para confirmação de presença:</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>self.setState({ modal_presence: false, modal_ttmse_id: null, modal_date_start: null, modal_date_finish: null, modal_ttmse_id: null, team_id: null, staff_id: null, modal_presence_value: null, team_id: null, confirm_all: 0,  confirm_full: 0, avaliation:0})}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
      <p> Está matéria não exige avaliação, preencha a data de finalização da prova ou presença.</p>
    </Modal.Header>
    <Modal.Body>
      <div className="row">
        <div className="col-md-4">
          <div className="form-group">
            <label>Data de início:</label>
            <InputMask value={self.state.modal_date_start} required maskChar={null} name="modal_date_start" mask="99/99/9999" className="form-control" onChange={self.handleChange.bind(self, 'modal_date_start')} placeholder="Data de início" />
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <label>Data de término:</label>
            <InputMask value={self.state.modal_date_finish} required maskChar={null} name="modal_date_finish" mask="99/99/9999" className="form-control" onChange={self.handleChange.bind(self, 'modal_date_finish')} placeholder="Data de término" />
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <label>&nbsp;</label>
            {(self.state.confirm_all == 0 && self.state.confirm_full == 0) ?
              <button onClick={() => { self.confirmarPresencaMateria(self.state.modal_ttmse_id, 1) }} className="btn btn-primary btn-block button-inline"><i className="fa fa-fw fa-save"></i> Salvar resultado de prova ou presença</button>
            :
              ''
            }
            {(self.state.confirm_all == 1) ?
              <button onClick={() => { self.confirmarPresenca(self.state.staff_id, self.state.modal_presence_value, self.state.team_id) }} className="btn btn-primary btn-block button-inline"><i className="fa fa-fw fa-save"></i> Salvar resultado de prova ou presença</button>
              :
              ''
            }
            {(self.state.confirm_full == 1) ?
              <button onClick={() => { self.confirmarTodasPresencas() }} className="btn btn-primary btn-block button-inline"><i className="fa fa-fw fa-save"></i> Salvar resultado de prova ou presença</button>
            :
              ''
            }
          </div>
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>self.setState({ modal_presence: false, modal_ttmse_id: null, modal_date_start: null, modal_date_finish: null, modal_ttmse_id: null, team_id: null, staff_id: null, modal_presence_value: null, team_id: null, confirm_all: 0,  confirm_full: 0, avaliation:0 })}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  <Modal show={self.state.modal_insercao} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Inserção de nota - {self.state.modal_insercao_titulo}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>self.setState({ modal_insercao: false, manual_grade: null, exam_id: null, import_ttmse_id: null })}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <div className="row">
        <div className="col-md-6">
          <h4>Associar a outra prova</h4>
          <hr/>
          <div className="form-group">
            <Select
              className="form-field-name"
              name="exam_id"
              value={self.state.exam_id}
              searchable={true}
              required
              placeholder={'Selecione a prova'}
              onChange={self.handleSelectChange.bind(self, 'exam_id')}
              options={self.state.lista_provas}
            />
          </div>
          <hr/>
          <button onClick={() => { self.insercaoManualCompleto(self.state.import_ttmse_id) }} className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> Salvar resultado de prova</button>
        </div>
        <div className="col-md-6">
          <h4>Inserir manualmente - <small><em>Não irá preencher as respostas, irá somente inserir resultado</em></small></h4>
          <hr/>
          <div className="form-group">
            <input required type="number" name="manual_grade" className="form-control" value={self.state.manual_grade} onChange={self.handleChange.bind(self, 'manual_grade')} />
          </div>
          <div className="form-group">
              <label>Data de realização da prova:</label>
              <InputMask value={this.state.date_start} required maskChar={null} name="date_start" mask="99/99/9999 99:99:99" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="dd/mm/aaaa hh:mm:ss" />
          </div>
          <hr/>
          <button onClick={() => { self.insercaoManualNota(self.state.import_ttmse_id) }} className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> Salvar resultado de prova</button>
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>self.setState({ modal_insercao: false, manual_grade: null, exam_id: null, import_ttmse_id: null })}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  <ModalHardConfirm
    show={this.state.modal_hard_confirm_open}
    onConfirm={this.confirmHardAction}
    onClose={() => this.setState({ modal_hard_confirm_open: false, pending_action: null })}
    title="Confirmação"
    mainMessage="Já existe um resultado registrado. Ao prosseguir, o resultado atual será sobrescrito e a integração automática com o SIGTRIP/SIGMEC não será feita novamente. Deseja realmente continuar?"
    confirmMessage={"Concordar"}
  />
</div>
    );
  }
}

export default TeamStaffsTab;



// WEBPACK FOOTER //
// ./src/Components/Teams/Elements/TeamStaffsTab.js